import { transactionService } from '../services'

const getAlertResumeByRegister = (filters)  => {
		return new Promise(resolve => {
			transactionService.getAlertResumeByRegister(filters)
				.then(response => resolve({ success: true, data: response.data }))
		})
}
export default getAlertResumeByRegister;
